import React, { useState } from 'react'
import styled from 'styled-components';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { useStore } from '../providers/store.provider';
import { OrdersComponent } from '../components/orders/OrderComponent';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const defaultInitDate = moment().startOf('month').toDate()
const defaultFinalDate = moment().endOf('month').toDate()

const defaultDates = { initialDate: defaultInitDate, finalDate: defaultFinalDate }

const OrdersPage = () => {

    const storeProvider = useStore();
    const storeInfo = useSelector((state) => state?.storeInfo);

    const [filters, setFilters] = useState(defaultDates)

    const isMultistore = storeProvider.getMultistoreState();
    const selectedMultistore = storeProvider.selectedMultistore?.id;
    const currentStoreId = isMultistore ? selectedMultistore : storeInfo?.id;
    const mergeFilters = { ...filters, storeId: currentStoreId };

    const handleFilter = ({ searchTerm, initialDate, finalDate, paymentMethod, paymentStatus, modality, schedule, id }) => {
        setFilters({ initialDate, finalDate, searchTerm, paymentMethod, paymentStatus, modality, schedule, id  })
    }

    return (
        <Wrapper>
            <OrdersComponent filters={mergeFilters} handleFilter={handleFilter}/>
        </Wrapper>
    )
}

export default OrdersPage